<template>
  <div v-show="entryEditContainerDisplay">
    <div class="action-overlay">
      <div class="container">
        <p>投稿を編集する</p>
        <div class="item">
          <mentionable
            :keys="data.keys"
            :items="data.items"
            :limit="data.mentionLimit"
            insert-space
            @open="onOpen">
            <textarea v-model="data.text" class="flextextarea-textarea" id="flextextarea" placeholder="ひろばでしゃべりたいことを書く" ref="area" :style="styles"></textarea>
            <template #no-result>
              <div class="dim">
                No result
              </div>
            </template>
            <template #item-@="{ item }">
              <div class="destination" v-if="!item.groupFlg">
                {{ item.lastName + item.firstName }}
                <span class="dim">
                  {{ item.nickname }}
                </span>
              </div>
              <div class="group" v-else>
                {{ item.name }}
                <span class="dim">
                  ({{ item.count }}名)
                </span>
              </div>
            </template>
            <template #item-#="{ item }">
              <div class="issue">
                {{ item.name }}
                <span class="number">
                  {{item.subName}}
                </span>
              </div>
            </template>
          </mentionable>
          <span class="focusborder"></span>

        </div> 
        <div class="action-all">
          <div class="tools">
            <div class="owner" v-if="data.entryDivisionId == 1">
              <!-- 広場のとき -->
              <span class="balloon">{{data.balloonSquare}}</span>
              <input type="checkbox" name="train" class="checkbox,owner" id="chuo" ref="disclosureIconCheckbox" />
              <label for="chuo" @click="followerOnly">
                <svg version="1.1" id="icon-owner" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                  y="0px" viewBox="0 0 600 600" style="enable-background:new 0 0 600 600;" xml:space="preserve">
                  <g>
                    <circle class="icon-owner" cx="252.98" cy="135.26" r="103.02"/>
                    <path class="icon-owner" d="M281.12,468.46c0-55.62,14.03-107.96,38.74-153.68c-21.07-3.76-43.53-5.81-66.88-5.81
                      c-119.37,0-216.14,53.08-216.14,118.56v121.93h254.49C284.67,523.56,281.12,496.43,281.12,468.46z"/>
                    <path class="icon-owner" d="M518.17,387.41h-5.32V348.63A78.2,78.2,0,0,0,490,293.89c-13.69-13.69-34.22-22.81-54.75-22.81a76.85,76.85,0,0,0-54.74,22.81c-13.69,13.68-22.81,34.21-22.81,54.74v38.78h-5.32c-19.77,0-34.22,15.21-34.22,34.22v95.8c0,19.77,14.45,34.22,34.22,34.22H518.93c19.77,0,34.22-14.45,34.22-34.22v-95.8A35.21,35.21,0,0,0,518.17,387.41ZM390.43,348.63c0-12.16,4.57-22.81,12.93-30.41,7.6-7.6,19-12.93,30.41-12.93A44.36,44.36,0,0,1,465,318.22a42.63,42.63,0,0,1,12.92,30.41v38.78H388.15V348.63Zm53.23,130.78,6.08,35.74H419.33l6.08-35.74c-7.6-3-15.21-12.92-15.21-22.05a23.69,23.69,0,0,1,23.57-23.57c13.69,0,24.34,11.41,24.34,23.57A21.53,21.53,0,0,1,443.66,479.41Z"/>
                  </g>
                </svg>
              </label>
            </div>
            <!-- サークルの時 -->
            <div class="owner" v-if="data.entryDivisionId == 2">
              <span class="balloon">{{data.balloonCircle}}</span>
              <input type="checkbox" name="train" class="checkbox,owner" id="chuo" ref="disclosureIconCheckbox" />
              <label for="chuo" @click="entryAsCircle">
                <svg version="1.1" id="icon-owner" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                  y="0px" viewBox="0 0 600 600" style="enable-background:new 0 0 600 600;" xml:space="preserve">
                  <g>
                    <circle class="icon-owner" cx="252.98" cy="135.26" r="103.02"/>
                    <path class="icon-owner" d="M281.12,468.46c0-55.62,14.03-107.96,38.74-153.68c-21.07-3.76-43.53-5.81-66.88-5.81
                      c-119.37,0-216.14,53.08-216.14,118.56v121.93h254.49C284.67,523.56,281.12,496.43,281.12,468.46z"/>
                    <path class="icon-owner" d="M559.99,472.88l-25.71-19.46c1.27-8.81,1.27-17.75,0-26.56l25.71-19.46c3.21-2.43,4.11-6.86,2.1-10.35
                      l-23.93-41.45c-2.01-3.49-6.3-4.93-10.01-3.36l-29.73,12.55c-7.02-5.51-14.79-10-23.07-13.34l-3.99-31.95
                      c-0.5-3.99-3.89-6.99-7.91-6.99h-47.86c-4.02,0-7.42,3-7.91,6.99l-3.99,31.95c-8.28,3.34-16.04,7.83-23.07,13.34l-29.73-12.55
                      c-3.71-1.57-8-0.12-10.01,3.36l-23.93,41.45c-2.01,3.48-1.11,7.92,2.1,10.35l25.71,19.46c-1.27,8.81-1.27,17.75,0,26.56
                      l-25.71,19.46c-3.21,2.43-4.11,6.86-2.1,10.35l23.93,41.45c2.01,3.48,6.3,4.93,10.01,3.36l29.73-12.55
                      c7.02,5.51,14.79,10,23.07,13.34l3.99,31.95c0.5,3.99,3.89,6.99,7.91,6.99h47.86c4.02,0,7.42-3,7.91-6.99l3.99-31.95
                      c8.28-3.34,16.04-7.83,23.07-13.34l29.73,12.55c3.71,1.57,8,0.12,10.01-3.36l23.93-41.45C564.1,479.74,563.2,475.3,559.99,472.88z
                      M439.52,472.04c-17.62,0-31.91-14.29-31.91-31.91c0-17.62,14.28-31.91,31.91-31.91c17.62,0,31.91,14.29,31.91,31.91
                      C471.4,457.75,457.13,472.02,439.52,472.04z"/>
                  </g>
                </svg>
              </label>
            </div>
            <!-- マイスペースの時 -->
            <div class="owner" v-if="data.entryDivisionId == 4">
              <span class="balloon">{{data.balloonMyspace}}</span>
              <input type="checkbox" name="train" class="checkbox,owner" id="chuo" ref="disclosureIconCheckbox" />
              <label for="chuo" @click="entryToSuare">
                <svg version="1.1" id="icon-owner" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                  y="0px" viewBox="0 0 600 600" style="enable-background:new 0 0 600 600;" xml:space="preserve">
                  <g>
                    <circle class="icon-owner" cx="252.98" cy="135.26" r="103.02"/>
                    <path class="icon-owner" d="M281.12,468.46c0-55.62,14.03-107.96,38.74-153.68c-21.07-3.76-43.53-5.81-66.88-5.81
                      c-119.37,0-216.14,53.08-216.14,118.56v121.93h254.49C284.67,523.56,281.12,496.43,281.12,468.46z"/>
                    <path class="icon-owner" d="M518.17,387.41h-5.32V348.63A78.2,78.2,0,0,0,490,293.89c-13.69-13.69-34.22-22.81-54.75-22.81a76.85,76.85,0,0,0-54.74,22.81c-13.69,13.68-22.81,34.21-22.81,54.74v.12h30.41v-.12h2.28c0-12.16,4.57-22.81,12.93-30.41,7.6-7.6,19-12.93,30.41-12.93A44.36,44.36,0,0,1,465,318.22a42.63,42.63,0,0,1,12.92,30.41v38.78H408.11v.15H349.35v0c-18.18,1.49-31.15,16.08-31.15,34.09v95.8c0,19.77,14.45,34.22,34.22,34.22H518.93c19.77,0,34.22-14.45,34.22-34.22v-95.8A35.21,35.21,0,0,0,518.17,387.41Zm-74.51,92,6.08,35.74H419.33l6.08-35.74c-7.6-3-15.21-12.92-15.21-22.05a23.69,23.69,0,0,1,23.57-23.57c13.69,0,24.34,11.41,24.34,23.57A21.53,21.53,0,0,1,443.66,479.41Z"/>
                  </g>
                </svg>
              </label>
          </div>
            <div class="emoji" @click="() => { data.emojiDialog =! data.emojiDialog }">
              <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="grin-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512" class="svg-inline--fa fa-grin-alt fa-w-16 fa-2x" style="color: rgb(36, 167, 255);"><path fill="currentColor" d="M200.3 248c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zm128 0c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3z" class=""></path></svg>
            </div>
            <div class="photo" @click="photoImageClick()">
              <svg version="1.1" id="icon-photo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 28.3 28.3" style="enable-background:new 0 0 28.3 28.3;" xml:space="preserve">
                <path class="st0" id="np_photo_2067966_000000" d="M25.7,7.3h-3.6l-0.6-3.6c-0.1-0.6-0.4-1.2-1-1.5c-0.5-0.4-1.1-0.5-1.7-0.4                    L2.3,4.7C1,4.9,0.2,6.1,0.4,7.4c0,0,0,0,0,0l2.5,14.3c0.1,0.6,0.5,1.1,1,1.5c0.4,0.3,0.9,0.4,1.3,0.4c0.1,0,0.3,0,0.4,0l1-0.2v0.8                    c0,1.3,1,2.3,2.3,2.3h16.7c1.3,0,2.3-1,2.3-2.3V9.7C28,8.4,27,7.4,25.7,7.3C25.7,7.3,25.7,7.3,25.7,7.3L25.7,7.3z M24.3,12.4                    c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5C23.7,10.9,24.3,11.6,24.3,12.4L24.3,12.4z M5.2,21.7                    c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.2-0.2-0.2-0.3L2.3,7.1c0-0.2,0.1-0.4,0.3-0.5c0,0,0,0,0,0L19,3.7h0.1c0.1,0,0.2,0,0.2,0.1                    c0.1,0.1,0.2,0.2,0.2,0.3l0.6,3.3H9c-1.3,0-2.3,1-2.3,2.3v11.8L5.2,21.7z M25.7,24.6H9c-0.2,0-0.4-0.2-0.4-0.4c0,0,0,0,0,0v-4L14,14                    c0.1-0.2,0.3-0.2,0.5-0.1c0,0,0,0,0.1,0.1l3.4,3.8C18,17.9,18,18,18,18.1l-0.4,2c0,0.1,0,0.1,0.1,0.2c0.1,0,0.1,0,0.1,0l3.4-3.7                    c0.1-0.1,0.2-0.1,0.4,0c0,0,0,0,0,0l4.5,4.9v2.8C26.1,24.4,25.9,24.6,25.7,24.6C25.7,24.6,25.7,24.6,25.7,24.6L25.7,24.6z"></path>
              </svg>
            </div>
          </div>
          <div class="action">  
            <button class="cancel" @click="cancel">キャンセル</button>
            <button class="confirm" @click="save">保存する</button>
          </div>
        </div>
        <c-emoji-dialog v-show="data.emojiDialog" @add-emoji="(val) => { addEmoji(val) }" />
        <div v-if="entry != null && Boolean(entry.has_thumbnail)">
          <c-thumbnail-image :entry-id="entry.id" />
        </div>
        <input @change="changeFile" type="file" class="hide-photo" :model="img" ref="hide_photo" />
        <div v-show="imgStates.resizedImg" class="resize-img__preview">
          <div class="resize-img__preview__circle" @click="clearAttachImg">
            <div v-if="imgStates.fileName">[{{ imgStates.fileName }}]</div>
            <img :src="imgStates.resizedImg" class="resize-img__preview__img" ref="preview_img">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.hide-photo {
  display: none;
}
</style>
<script setup>
import axios from 'axios'
import Global from '@/js/constant.js'
import mention from '@/js/components/mention.js'
import imageHandler from '@/js/components/image-handler.js'
import mentionUtils from '@/js/mention-utils.js'
import _ from 'lodash'
import { computed, nextTick, reactive, useTemplateRef, watch } from 'vue'
import { useStore } from 'vuex'
import { useToast } from 'vue-toast-notification'

const $store = useStore()
const $toast = useToast()

const $area = useTemplateRef('area')
const $disclosureIconCheckbox = useTemplateRef('disclosureIconCheckbox')
const $hidePhoto = useTemplateRef('hide_photo')
const $previewImg = useTemplateRef('preview_img')

const {mentionStates} = mention()
const {imgStates, attachImg} = imageHandler()
const data = reactive({
  entry: null,
  entryDivisionId: null,

  hashtagIds: null,
  destinationIds: null,
  destinationGroupIds: null,
  text: "",
  keys : ['@', '#'],
  mentionLimit: Global.vue_mention_limit,
  items: [],
  accounts: [],
  groups: [],
  groupToAccounts: {},
  localHashtags: [],
  emojiDialog: false,
  officialRange: null,
  entryToSquareFlg: false,
  entryAsCircleFlg: false,
  followerOnlyFlg: false,
  height: "90px",
  balloonSquare: '広場に投稿',
  balloonCircle: '個人として投稿',
  balloonMyspace: 'フォロワー限定',
})
// computed
const styles = computed(() => {
  return {
    "height": data.height,
  }
})
// mapState
const entryEditContainerDisplay = computed(() => $store.state.entry.entryEditContainerDisplay)
const entryEditContainerContext = computed(() => $store.state.entry.entryEditContainerContext)
const allAccounts = computed(() => $store.state.allAccounts.accounts)
const circles = computed(() => $store.state.circles.circles)
const followers = computed(() => $store.state.follows.followers)
const squareHashtags = computed(() => $store.state.hashtag.squareHashtags)

// mapmutations
const setEntryReloadFlg = (val) => $store.commit('setEntryReloadFlg', val)
const setEntryReloadId = (val) => $store.commit('setEntryReloadId', val)
const setEntryEditContainerDisplay = (val) => $store.commit('setEntryEditContainerDisplay', val)
const setEntryEditContainerContext = (val) => $store.commit('setEntryEditContainerContext', val)
const initEntryEditContainerContext = (val) => $store.commit('initEntryEditContainerContext', val)
const setClientErrors = (val) => $store.commit('setClientErrors', val)

// watch : {
watch(entryEditContainerContext, (newEntryEditContext) => {
  if (!newEntryEditContext.entry) {
    data.entry = null
    data.entryDivisionId = null
    data.text = null
    data.items = []
    return
  }
  // メンションに出すアカウント候補取得
  mentionStates.mentionDestinations = getMentionDestinations(newEntryEditContext)
  // メンションに出すハッシュタグ候補取得
  mentionStates.mentionHashtags = getMentionHashtags(newEntryEditContext)
  data.entry = newEntryEditContext.entry
  data.entryDivisionId = newEntryEditContext.entry.entry_division_id
  // テキストよりハッシュタグ文字列（#タグ：１）を作成
  data.text = newEntryEditContext.entry.text
  // テキストよりグループ文字列（#グループ：１）を作成
  if (newEntryEditContext.entry.entry_division_id == Global.entry_division_id.circle 
      || newEntryEditContext.entry_division_id == Global.entry_division_id.private_circle) data.text = mentionUtils.setGroupIdsToText(data.text, data.groups)
  if (newEntryEditContext.entry.entry_division_id === Global.entry_division_id.myspace) data.keys = ['@'] 

  if (mentionStates.mentionDestinations.length > 0) {
    mentionStates.mentionDestinations = mentionStates.mentionDestinations.concat(mentionUtils.getHereState())
  }
  // つぶやき範囲ボタンの制御
  setDisclosureInformatons(newEntryEditContext)
})
watch(() => data.text, () => {
  if (data.text != null) {
    resize()
  }
})

// methods
const cancel = () => {
  setEntryEditContainerDisplay(false);
  initEntryEditContainerContext();
}
const save = async () => {
  if (mentionUtils.isEpty(data.text, data.accounts, data.groups, squareHashtags.value)) {
    $toast.error("no tweet")
    return
  }
  let destinationGroupIds = mentionUtils.getGroupIdsFromText(data.text, data.groups)
  data.text = mentionUtils.changeGroupToMembers(data.text, data.groupToAccounts)
  let destinationIds = mentionUtils.getDestinationIdsFromText(data.text, data.accounts, [])
  data.hashtagIds = mentionUtils.getHashtagIdsFromText(data.entry.entry_division_id, data.text, data.localHashtags)
  data.text = mentionUtils.deleteAccountIdFromText(data.text, data.accounts, [])
  var formData = new FormData()
  formData.append("insert_flg", Global.OFF)
  formData.append("id", data.entry.id)
  formData.append("entry_division_id", getEngryDivisionIdByDiclosureFlg())
  formData.append("text", data.text)
  
  if(data.entryAsCircleFlg) formData.append("entry_as_circle", true)
  formData.append("all_dest_flg", mentionUtils.getAllDestFlg(data.text))

  if(data.hashtagIds) formData.append("hashtag_ids", data.hashtagIds)
  if(data.destinationIds) formData.append("destination_ids", destinationIds)
  if(data.destinationGroupIds) formData.append("destination_group_ids", destinationGroupIds)
  if(imgStates.img) {
    formData.append("img", imgStates.img)
    formData.append("thumbnail", imgStates.img)
  }
  if(data.officialRange != null) formData.append("official_range", data.officialRange)
  formData.append("version_no", data.entry.version_no)

  await axios.post(Global.url.api_entries_tweet, formData)
  .then(res => {
    if (res.data.status == Global.api_status.success) {
      data.text = ""

      data.hashtagIds = []
      data.destinationIds = []

      clearAttachImg()
      setEntryReloadFlg(true)
      setEntryReloadId(data.entry.id)
      setEntryEditContainerDisplay(false)
      setEntryEditContainerContext({
        entry: null
      })
      $toast.info("つぶやき更新しました")
      return
    }
    $toast.error("failed")
  })
  .catch(error=>{
    $toast.error('client error')
    setClientErrors({func:"common/entry-edit.vue::save", params: formData, errorMessage:error})
  })
}
const onOpen = (key) => {
  if (data.entryDivisionId === Global.entry_division_id.myspace) {
    data.items = mentionStates.mentionDestinations
    return
  }
  data.items = key === '@' ? mentionStates.mentionDestinations : mentionStates.mentionHashtags
}
const getMentionDestinations = (newEntryEditContext) => {
  if (newEntryEditContext.entry.entry_division_id == Global.entry_division_id.square) {
    data.accounts = allAccounts.value
    return data.accounts.map(row => { return mentionUtils.getMentionStates(row) })
  }
  if (newEntryEditContext.entry.entry_division_id == Global.entry_division_id.circle || newEntryEditContext.entry_division_id == Global.entry_division_id.private_circle) {
    let filterCircle = _.keyBy(circles.value, 'id')[newEntryEditContext.entry.circle_id]
    data.accounts = filterCircle.members
    data.groups = filterCircle.groups
    data.groupToAccounts = mentionUtils.createGroupMentionToMembersMentionConverter(filterCircle.groups)
    let res = filterCircle.members.map(r => mentionUtils.getMentionStates(r))
    return res.concat(filterCircle.groups.map(r => mentionUtils.getMentionGroupsStates(r)))
  }
  if (newEntryEditContext.entry.entry_division_id == Global.entry_division_id.my_space) {
    data.accounts = followers.value.map(r => r.follow_account)
    return data.accounts.map(r => mentionUtils.getMentionStates(r))
  }
  return []
}
const getMentionHashtags = (newEntryEditContext) => {
  // 広場のハッシュタグ取得
  if (newEntryEditContext.entry.entry_division_id == Global.entry_division_id.square) {
    data.localHashtags = squareHashtags.value
    return squareHashtags.value.map(row => { return mentionUtils.getMentionHashtagStates(newEntryEditContext.entry.entry_division_id, row) })
  }
  // サークルのハッシュタグ取得
  if ([Global.entry_division_id.circle, Global.entry_division_id.private_circle].includes(newEntryEditContext.entry.entry_division_id)) {
    let filterCircle = _.keyBy(circles.value, 'id')[newEntryEditContext.entry.circle_id]
    data.localHashtags = filterCircle.hashtags
    // サークル(外部モード)
    if (newEntryEditContext.entry.entry_division_id == Global.entry_division_id.circle) {
      let filteredHashtags = filterCircle.hashtags.filter(h => h.official_circle == true)
      return filteredHashtags.map(row => mentionUtils.getMentionHashtagStates(newEntryEditContext.entry.entry_division_id, row))
    }
    // サークル(内部モード)
    let filteredHashtags = filterCircle.hashtags.filter(h => h.official_circle == false)
    return filteredHashtags.map(row => mentionUtils.getMentionHashtagStates(newEntryEditContext.entry.entry_division_id, row))
  }
  return []
}
const addEmoji = (val) => {
  if (val) {
    data.text = data.text + val
  }
  data.emojiDialog = false
}
const photoImageClick = () => {
  $hidePhoto.value.click()
}
const clearAttachImg = () => {
  imgStates.fileName = null;
  imgStates.img = null;
  imgStates.resizedImg = null;

  if ($previewImg && $previewImg.value !== undefined) {
    $previewImg.value = '';
    window.URL.revokeObjectURL(imgStates.resizedImg);
  }
}
const followerOnly = () => {
  data.followerOnlyFlg = !data.followerOnlyFlg
  data.officialRange = !data.followerOnlyFlg ? null : Global.entry_division_id.myspace
  data.balloonSquare = !data.followerOnlyFlg ? '広場に投稿' : 'フォロワー限定' 
}
const entryAsCircle = () => {
  data.entryAsCircleFlg = !data.entryAsCircleFlg
  data.balloonCircle = !data.entryAsCircleFlg ? '個人として投稿' : 'サークルとして投稿' 
}
const entryToSuare = () => {
  data.entryToSquareFlg = !data.entryToSquareFlg
  data.officialRange = !data.entryToSquareFlg ? Global.entry_division_id.myspace : Global.entry_division_id.square
  data.balloonMyspace = !data.entryToSquareFlg ? 'フォロワー限定' : '広場に投稿' 
}
const setDisclosureInformatons = (context) => {
  if (context.entry.entry_division_id === Global.entry_division_id.square) {
    data.followerOnlyFlg = context.entry.official_range === Global.entry_division_id.myspace ? true : false
    $disclosureIconCheckbox.checked = data.followerOnlyFlg
    data.balloonSquare = !data.followerOnlyFlg ? '広場に投稿' : 'フォロワー限定' 
  } else if (context.entry.entry_division_id === Global.entry_division_id.circle || context.entry.entry_division_id === Global.entry_division_id.private_circle) {
    data.entryAsCircleFlg = context.entry.entry_as_circle === true
    $disclosureIconCheckbox.checked = data.entryAsCircleFlg
    data.balloonCircle = !data.entryAsCircleFlg ? '個人として投稿' : 'サークルとして投稿' 
  } else if (context.entry.entry_division_id === Global.entry_division_id.myspace) {
    data.entryToSquareFlg = context.entry.official_range === Global.entry_division_id.square ? true : false
    $disclosureIconCheckbox.checked = data.entryToSquareFlg
    data.balloonMyspace = !data.entryToSquareFlg ? 'フォロワー限定' : '広場に投稿' 
  }
  data.officialRange = context.entry.official_range
}
// const initDicsclosureCheckbox = (context) => {
//   if (context.entry.entry_division_id === Global.entry_division_id.square) {
//     $disclosureIconCheckbox.value.checked = data.followerOnlyFlg
//   } else if (context.entry.entry_division_id === Global.entry_division_id.circle || context.entry.entry_division_id === Global.entry_division_id.private_circle) {
//     $disclosureIconCheckbox.value.checked = data.entryAsCircleFlg
//   } else if (context.entry.entry_division_id === Global.entry_division_id.myspace) {
//     $disclosureIconCheckbox.value.checked = data.entryToSquareFlg
//   }
// }
const getEngryDivisionIdByDiclosureFlg = () => {
  return data.entryDivisionId
}
const resize = () => {
  if (!$area.value?.scrollHeight) return
  data.height = $area.value.scrollHeight + 'px'
  data.height = "auto"
  nextTick(() => {
    data.height = $area.value.scrollHeight + 'px'
  })
}
const changeFile = (e) => {
  attachImg(Global.img_handle_mode.time_line, e)
}
</script>
<!-- <script>
export default {
  data () {
    return {
      mentionDestinations: null,
      mentionHashtags: null,
      img: null,
      thumbnail: null,
      resizedImg:[],
    }
  },
}
</script> -->